import { jsonApi } from '@models/jsonApi';

jsonApi.define('dms/modifier', {
  name: '',
  arguments: '',
});
